<template>
    <div class="loader loaderPageDetails" v-show="this.isLoading"></div> 
    <section  v-show="!this.isLoading">
        <div class="Container">
            <div class="Box BackToOrder"><a @click="this.back()">{{ this.risorse['back'] }}</a></div>
            <div class="Box MainClientData">
                <div class="MainClientIndex">
                    <div class="MainClientCode">{{ this.risorse['idDoc'] }}: <span>{{ this.docId }}</span></div>
                    <div class="MainClientCode">
                        <div class="Button Iconed Small Slim Download" @click="this.generatePDF()">
                            <a>{{ this.risorse['scaricaDoc'] }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="this.ShowGrid" class="Container" ref="pdfContent">
            <div class="Box MainClientData">
                <div class="TopHeader NotVisible" >
                    <div class="Container">
                        <div class="Box">
                            <div class="Logo">
                                <a><img src="/images/Logo.png" alt="Cressi" ref="headerImage"/></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="Frame MainClientInfo">
                    <div class="MainClientAddData">
                        <div class="MainClientDataList">
                            <ul>
                                <li>{{ this.risorse['NumeroDocumento'] }}: <span>{{ this.fatturaHead?.NumeroDocumento }}</span></li>
                                <li>{{ this.risorse['annoDoc'] }}: <span>{{ this.fatturaHead?.AnnoDocumento }}</span></li>
                                <li>{{ this.risorse['tipoDoc'] }}: <span>{{ this.fatturaHead?.TipoDocumento }}</span></li>
                                <li>{{ this.risorse['dtDoc'] }}: <span>{{ this.formatDateNoOre(this.fatturaHead?.DataDocumento) }}</span></li>
                            </ul>
                            <ul>
                                <li>{{ this.risorse['ragSoc'] }}: <span>{{ this.fatturaHead?.Nome}}</span></li>
                                <li>{{ this.risorse['codiceCliente'] }}: <span>{{ this.fatturaHead?.CodiceGest}}</span></li>
                            </ul>
                            <ul>
                                <li>{{ this.risorse['codiceIndirizzo'] }}: <span>{{ this.fatturaHead?.CodiceDestinazione }}</span></li>
                                <li>{{ this.risorse['descrDest'] }}: <span>{{ this.fatturaHead?.DescrizioneDestinazione }}</span></li>
                                <li>{{ this.risorse['Indirizzo'] }}: <span>{{ this.fatturaHead?.Indirizzo }}</span></li>
                                <li>{{ this.risorse['cap'] }}: <span>{{ this.fatturaHead?.Cap }}</span></li>
                                <li>{{ this.risorse['citta'] }}: <span>{{ this.fatturaHead?.Citta }}</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="Box">
                <div class="Frame Deadlines">
                    <div class="HistoryTable Table">
                        <table width="100%" border="0" cellspacing="0" cellpadding="0">
                            <tbody>
                                <tr class="TableRow">
                                    <th scope="col">{{ this.risorse['TabVarCodice'] }}</th>
                                    <th scope="col">{{ this.risorse['descrProd'] }}</th>
                                    <th scope="col">{{ this.risorse['TabVarStock'] }}</th>
                                    <th scope="col" class="CenteredText">{{ this.risorse['TabVarPrezzoUn'] }}</th>
                                    <th scope="col">{{ this.risorse['quantita'] }}</th>
                                    <th scope="col" class="DxText">{{ this.risorse['TotaleProdotti'] }}</th>
                                    <th scope="col">{{ this.risorse['docRef'] }}</th>
                                </tr>
                                <tr v-for="fattura in this.righeFattura" :key="fattura.IdDocumento">
                                    <td>{{ fattura?.IdArticolo }}</td>
                                    <td>{{ fattura?.Descrizione }}</td>
                                    <td>{{ fattura?.Stock }}</td>
                                    <td>{{ this.formatNumber(fattura?.PrezzoUnitario, 2, ',', '.') }}</td>
                                    <td>{{ this.formatNumber(fattura?.Quantita, 2, ',', '.') }}</td>
                                    <td class="CenteredText">{{ this.formatNumber(fattura?.PrezzoTotale, 2, ',', '.') }}</td>
                                    <td class="CenteredText">{{ fattura?.DocRef }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import{
    risorseMixin,
    dateMixin,
    priceMixin
} from '@/mixin.js';
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import DocumentiService from '@/services/documenti.service.js';

export default {
    name: "SchedaFattura",
    mixins:[risorseMixin,dateMixin,priceMixin],
    data(){
        return {
            docId: null,
            righeFattura: [],
            fatturaHead:{},
            ShowGrid: true,
            isLoading: false
        }
    },
    mounted:function(){
        this.docId = this.$route.params.idDoc;
        this.fatturaHead = this.$store.getters.getTestaFattura;
        this.GetData(this.docId);
    },
    methods:{
        GetData: function(idDoc){
            this.isLoading = true;
            DocumentiService.getFattura(this.$store.getters.getLingua, this.$store.getters.getToken,idDoc).then(
                data => {
                    if(data){
                        this.righeFattura = data;
                    }
                    this.isLoading = false;
                }
            );
        },
        async generatePDF() {
            try{
                this.$store.commit('setLoading', true);
                const content = this.$refs.pdfContent;
                const headerImage = this.$refs.headerImage;

                const canvas = await html2canvas(content, { scale: 2 }); 
                const imgData = canvas.toDataURL("image/png");
                const pdf = new jsPDF("p", "mm", "a4");

                const headerImg = new Image();
                headerImg.src = headerImage.src;
                headerImg.onload = () => {
                    const headerImgData = headerImg.src;
                    const headerImgWidth = 30;
                    const headerImgHeight = 10;
                    pdf.addImage(headerImgData, 'PNG', 90, 2, headerImgWidth, headerImgHeight);

                    const imgProps = pdf.getImageProperties(imgData);
                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                    pdf.addImage(imgData, 'PNG', 0, headerImgHeight, pdfWidth, pdfHeight);

                    if (pdfHeight + headerImgHeight > pdf.internal.pageSize.getHeight()) {
                        const totalPages = Math.ceil((pdfHeight + headerImgHeight) / pdf.internal.pageSize.getHeight());
                        for (let i = 1; i < totalPages; i++) {
                        pdf.addPage();
                        pdf.addImage(imgData, 'PNG', 0, -pdf.internal.pageSize.getHeight() * i + headerImgHeight, pdfWidth, pdfHeight);
                        }
                    }

                    const pdfBlob = pdf.output('blob');
                    const pdfUrl = URL.createObjectURL(pdfBlob);
                    window.open(pdfUrl);
                };
            }finally{
                this.$store.commit('setLoading', false);
            }
        },
        back(){
            this.$router.push({name: 'Documenti'});
        }
    }
}
</script>
<style>
.NotVisible{
    display: none;
}
</style>